import {TextEncoder} from "encoding";
import Bottleneck from "bottleneck";
import sleep from "sleep";
import Device from "../device.js";


const TIMEOUT = 500;

class Module extends Device {
  static constructor() {
  }
  constructor(serialPort) {
    super(serialPort);
    
    this.id = "uninitialized";
    this.status = "uninitialized";    
    
    this.__serialPort = serialPort;

    this.limiter = new Bottleneck({
      maxConcurrent: 1,
      minTime: 10
    });    
    
    jfermi.RM_thermostat2l_clearErrorFlags = this.RM_thermostat2l_clearErrorFlags.bind(this);
    jfermi.RM_thermostat2l_setPWM = this.RM_thermostat2l_setPWM.bind(this);
  }
  async initialize() {
    try {            
      await this.__serialPort.open({
        baudRate: 9600,
        dataBits: 8,
        parity: "none",
        stopBits: 1    
      });      
      this.status = "OK";
      
      this.name = "thermostat2l";

      this.id = await this.getVersion();
            
      await this.update();
      
    } catch(e) {
      this.status = "Failed";
      throw e;
    }
  }
  async update() {
    try {                    
      this.status = "Ok";
      
      this.errorFlags = await this.command("GetErrorFlags");
      this.percentage = await this.command("GetPWM0");
      this.value = "TODO";
      
    } catch(e) {
      this.value = "-";
      this.status = `Failed: ${e}`;
      throw e;      
    }      
  }
  async __flush() {
    var reader = this.__serialPort.readable.getReader();

    /* flush queue */
    try {      
      setTimeout(function() {
        reader.releaseLock();
      }, 10);      
      while (true) {        
        const chunk = await reader.read();     
        if (Module.logLevel>2) console.log(`flushing ${chunk.value.byteLength} bytes(s)`);
      }
    } catch(e) {
      if (!(e instanceof TypeError))
        throw e;
    }    
  }
  /* sending new command to the device while waiting for the response may cause concurrency problems           */
  /* so we wrapped the function and limited the maximum number of concurrent calls to 1 with bottlenck library */  
  async command(command) {
    return await this.limiter.schedule(() => this.command_wrapped(command));
  }
  async command_wrapped(command) {
    await this.__flush();

    var reader;

    var promise = new Promise(async function(resolve, reject) {             
      const encoder = new TextEncoder();
      const writer = this.__serialPort.writable.getWriter();
      await writer.write(encoder.encode(`${command}\n`).buffer);
      writer.releaseLock();    
      reader = this.__serialPort.readable.getReader();

      var result = "";

      try {
        while (true) {
          const { value, done } = await reader.read();      
          result += String.fromCharCode.apply(null, new Uint8Array(value));      

          if (done) {
            // reader has been canceled.               
            reject( new Error("reader cancelled") );
            break;
          }        

          if (result.endsWith('\n')) {
            if (result.startsWith("ERR")) {
              result = result.replace("\r\n", "");
              result = result.replace("\r", "");
              result = result.replace("\n", "");
              result = result.replace(" ", "");
              result = result.replace("ERR", "");              
              reject( new Error(result) );
              break;
            } else {
              result = result.replace("\r\n", "");
              result = result.replace("\r", "");
              result = result.replace("\n", "");
              result = result.replace(" ", "");
              result = result.replace("OK", "");      
              resolve(result);
              break;
            }
          }
        } //while
        reader.releaseLock();  
      } catch(e) {
        if (e instanceof TypeError) {
          reject( new Error("timeout") );
        } else {  
          throw e;        
        }
      }
    }.bind(this));

    var promiseTimeout = new Promise(function(resolve, reject) {
      setTimeout(function() {        
        reader.releaseLock();        
        reject( new Error("timeout"));
      }, TIMEOUT);
    }.bind(this));

    return Promise.race([promise, promiseTimeout]);    

  }
  async getVersion() {
    return await this.command("GetVersion");
  }
  async RM_thermostat2l_clearErrorFlags() {
    return await this.command("SetErrorFlags 0");
  }
  async RM_thermostat2l_setPWM(event, value) {
    if (value>0) {
      console.log(`SetPWM0 ${value}`);
      await this.command(`SetPWM0 ${value}`);
      await this.command(`SetPWM1 0`);
    } else if (value<0) {
      await this.command(`SetPWM1 ${Math.abs(value)}`);
      await this.command(`SetPWM0 0`);
    } else {
      await this.command(`SetPWM0 0`);
      await this.command(`SetPWM1 0`);
    }
  }
  toJSON() {
    return({
      id: this.id,
      status: this.status,
      errorFlags: this.errorFlags,
      percentage: this.percentage
    });
  }
}

Module.logLevel = 2;

Module.constructor();

export default Module;